import Button from '@/component/Button'
import CurrencyIcon from '@/component/CurrencyIcon'
import WalletContext from '@/context/WalletContext'
import { PopUpStore } from '@/store/PopupStore'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

const DiamondBalance: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const { wallet } = useContext(WalletContext)

  const diamondCurrency = wallet?.diamond

  const handleTopUpClick = () => {
    PopUpStore.setTopUpDiamondPopupVisible(true)
  }

  if (!diamondCurrency) {
    return null
  }

  return (
    <div>
      <p className="mb-sm text-base font-custom-bold">
        {t('currency.diamond')} {t('title.balance')}
      </p>
      <div className="flex items-center">
        <div className="flex flex-grow items-center gap-sm">
          <CurrencyIcon code="diamond" size="large" />
          <span className="text-4xl font-custom-bold">{wallet.diamond?.balance}</span>
        </div>
        <div>
          <Button className="px-md font-normal leading-5" type="primary" size="small" onClick={handleTopUpClick}>
            {t('btn.topUpDiamond')}
          </Button>
        </div>
      </div>
    </div>
  )
}

interface PropType {}

export default DiamondBalance
